import { useTranslation } from 'react-i18next';
import { useAuthUser } from '../../hooks/useUser';
import { RouteNameEnum, useRoutes } from '../../navigation';
import { showErrorToast } from '../Shared/showToast';
import OnboardingGoalButton from './OnboardingGoalButton';
import { buildAuthenticatedBaselineSurveyUrl } from './baselineSurvey';
import { OnboardingGoalType } from './types';

import { EnrollmentsTooltip, OperationsTooltip, PaymentsTooltip } from './OnboardingGoalTooltips';
{
  /* //FamiliesTooltip (add in imports above) commented code for 2434 'Communicate with families' This block of code will be enabled in future. */
}

type GoalButtonProps = {
  onboardingGoal: OnboardingGoalType;
  onClick?: (onboardingGoal: OnboardingGoalType) => void;
};

function BaselineSurveyGoalButton({ onboardingGoal }: GoalButtonProps) {
  const { t } = useTranslation();
  const { token } = useAuthUser();

  return (
    <OnboardingGoalButton
      label="onboarding.buttonBaselineSurvey"
      onboardingGoal={onboardingGoal}
      onClick={() => {
        try {
          if (!token) throw new Error('No authenticated user');

          window.location.assign(buildAuthenticatedBaselineSurveyUrl(token));
        } catch {
          showErrorToast(t('onboarding.errorTitle'), t('onboarding.navigationError', { path: 'baseline survey' }));
        }
      }}
    />
  );
}

const EnrollmentsGoalButton: React.FC<GoalButtonProps> = ({ onboardingGoal }) => {
  const { t } = useTranslation();

  const { getRoutePath, getRoute } = useRoutes();

  return (
    <EnrollmentsTooltip>
      <OnboardingGoalButton
        label="onboarding.buttonEnrollments" // gets tranlated in OnboardingGoalButton
        onboardingGoal={onboardingGoal}
        onClick={async () => {
          const route = getRoute(RouteNameEnum.ONBOARDING);
          if (route) {
            const path = getRoutePath(route);
            window.location.assign(path);
          } else {
            showErrorToast(
              t('onboarding.errorTitle'),
              t('onboarding.navigationError', { path: RouteNameEnum.UPDATE_WEBSITE })
            );
          }
        }}
      />
    </EnrollmentsTooltip>
  );
};
/* commented code for 2434 'Communicate with families' This block of code will be enabled in future. */
/* const FamiliesGoalButton: React.FC<GoalButtonProps> = ({ onboardingGoal, onClick }) => {
  return (
    <FamiliesTooltip>
      <OnboardingGoalButton
        label="onboarding.buttonFamilies" // gets tranlated in OnboardingGoalButton
        onboardingGoal={onboardingGoal}
        onClick={() => {
          if (onClick) onClick(onboardingGoal);
        }}
      />
    </FamiliesTooltip>
  );
};
*/
const PaymentsGoalButton: React.FC<GoalButtonProps> = ({ onboardingGoal, onClick }) => {
  return (
    <PaymentsTooltip>
      <OnboardingGoalButton
        label="onboarding.buttonPayments" // gets tranlated in OnboardingGoalButton
        onboardingGoal={onboardingGoal}
        onClick={() => {
          if (onClick) onClick(onboardingGoal);
        }}
      />
    </PaymentsTooltip>
  );
};
const OperationsGoalButton: React.FC<GoalButtonProps> = ({ onboardingGoal, onClick }) => {
  return (
    <OperationsTooltip>
      <OnboardingGoalButton
        label="onboarding.buttonOperations" // gets tranlated in OnboardingGoalButton
        onboardingGoal={onboardingGoal}
        onClick={() => {
          if (onClick) onClick(onboardingGoal);
        }}
      />
    </OperationsTooltip>
  );
};

export { BaselineSurveyGoalButton, EnrollmentsGoalButton, OperationsGoalButton, PaymentsGoalButton }; // FamiliesGoalButton
